<template>
  <div>
    <h3>
      <b>{{ $t('FAQ.accountPurchase') }}</b>
    </h3>
    <hr />
    <h3>
      <b>2.1 Pembelian Akun Melalui Aplikasi Mobile</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih “Penawaran” di bagian "Menu Pilihan Untuk Kamu" di beranda pada tampilan aplikasi
        mobile anda
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_2.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Atau, pilih “Beli Paket” di toolbar bagian bawah aplikasi mobile anda, berada di posisi
        kedua sisi kiri bawah aplikasi
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_3.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Pilih tipe membership yang anda inginkan dengan menekan kotak paket membership
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_4.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Geser ke bawah dan tekan tombol “Lanjut ke Checkout”
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_5.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>Lanjut ke bagian Cara Pembayaran</li>
    </ul>
    <hr />
    <h3>
      <b>2.2 Pembelian Akun Melalui Browser PC/Laptop</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih “Beli Membership Sekarang” di halaman beranda pada tampilan browser anda
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/image67.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Atau, pilih “Beli Paket” di toolbar bagian kiri atas tampilan browser anda
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/desktop/desktop_16_2.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Pilih tipe membership yang anda inginkan dengan menekan kotak paket membership
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/image71.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>Tekan tombol “Lanjut ke Checkout”</li>
      <br />
      <li>Lanjut ke bagian Cara Pembayaran</li>
    </ul>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'AccountPurchase',
};
</script>

<style></style>
